import React from 'react';
import { Link } from '@primer/react'

export default function About() {
  return (
    <div className="about d-flex flex-1 flex-column text-center flex-items-center">
      <p>I'm Maya, a full-stack software developer who reads, runs, and games in my free time.</p>
      <p>Location: Austin, Texas</p>
      <p>Workplace: <Link href="https://truemed.com/about">Truemed</Link></p>
      <p><br /></p>
      <p>Previously: <Link href="https://github.com/about">GitHub</Link>, <Link href="https://rev.com/about-rev">Rev.com</Link></p>
      <p>Education: Duke University - Computer Science</p>
    </div>
  );
}